import React from 'react';
import { Formik, Form } from 'formik';
import DateTimePicker from '../../shared/controls/form/dateTimePicker';
import { DateBox, TextArea, TextBox } from '../../shared/controls/form';
import SelectBox from '../../shared/controls/form/selectBox';

const ChildTicket = ({
  remindVisible,
  showReminderPage,
  handleBackClick,
  togglePopupVisibility,
  formData,
  handleDateTime,
  handleChangeForm,
  errormsg,
  handleChange,
  selectedOptions,
  ticketPriorityDropdown,
  owner,
  ticketStatusDropdown,
  handleReminderClick,
  loading,
  handleFormSubmit,
}) => {
  return (
    remindVisible && (
      <div id="genricPopup">
        <div className="popup-overlay">
          <div className="popup">
            <Formik>
              <Form>
                <div className="popup-header">
                  <h2>{showReminderPage ? 'Set Reminder' : 'Create Ticket'}</h2>
                  {showReminderPage ? (
                    <button
                      type="button"
                      className="btn btn-primary backButtonPopup"
                      aria-label="Back"
                      onClick={handleBackClick}
                    >
                      <svg
                        width="16px"
                        height="16px"
                        viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title>ionicons-v5-a</title>
                        <polyline
                          points="244 400 100 256 244 112"
                          style={{
                            fill: 'none',
                            stroke: '#ffffff',
                            strokeLinecap: 'round',
                            strokeLinejoin: 'round',
                            strokeWidth: '60px',
                          }}
                        />
                        <line
                          x1="120"
                          y1="256"
                          x2="412"
                          y2="256"
                          style={{
                            fill: 'none',
                            stroke: '#ffffff',
                            strokeLinecap: 'round',
                            strokeLinejoin: 'round',
                            strokeWidth: '60px',
                          }}
                        />
                      </svg>
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="custom-btn-close"
                      aria-label="Close"
                      onClick={togglePopupVisibility}
                    ></button>
                  )}
                </div>

                <div className="content-area">
                  <div className="row">
                    {showReminderPage ? (
                      <div className="col-md-12">
                        <div className="input-container" id="datetime">
                          <label htmlFor="reminderDate">Reminder</label>
                          <div className="flexdate" style={{ width: '320px' }}>
                            <div onClick={handleReminderClick}>
                              <span className="radio-inner"></span>
                            </div>

                            <DateTimePicker
                              value={formData.reminder}
                              onChange={handleDateTime}
                              name="reminder"
                              placeholder="Select reminder date & time"
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="col-md-6">
                          <div className="input-container">
                            <TextBox
                              label={'Subject'}
                              name={'subject'}
                              isRequired={true}
                              placeholder={'Enter Subject'}
                              value={formData?.subject}
                              handleChange={handleChangeForm}
                              errormsg={errormsg?.subject}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="input-container">
                            <DateBox
                              label={'Due Date'}
                              name={'dueDate'}
                              placeholder={'Enter Date'}
                              value={formData?.dueDate ? formData?.dueDate.substring(0, 10) : ''}
                              minDate={new Date().toISOString().split('T')[0]}
                              handleChange={handleChangeForm}
                              errormsg={errormsg?.dueDate}
                            />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="input-container" id="taskpriority">
                            <SelectBox
                              label={'Priority'}
                              name={'priorityId'}
                              value={formData?.priority}
                              selectedOptions={selectedOptions?.priorityId}
                              placeholder={formData?.priority}
                              handleSelect={handleChange}
                              options={ticketPriorityDropdown}
                              optionKeys={['id', 'displayName']}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  borderColor: state.isFocused ? '#365397' : base.borderColor,
                                  borderWidth: state.isFocused ? '1px' : base.borderWidth,
                                  boxShadow: state.isFocused
                                    ? '0 0 5px rgba(0, 86, 179, 0.3)'
                                    : 'none',
                                  transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                                  '&:hover': {
                                    borderColor: '#365397',
                                  },
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  zIndex: 99999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? '#DEEBFF'
                                    : state.isFocused
                                      ? '#DEEBFF'
                                      : base.backgroundColor,
                                  color: state.isSelected
                                    ? '#222'
                                    : state.isFocused
                                      ? '#222'
                                      : base.color,
                                  cursor: 'pointer',
                                }),
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="input-container">
                            <SelectBox
                              label={'Ticket Owner'}
                              name={'ownerId'}
                              placeholder={formData?.owner || 'Select Owner'}
                              isRequired={true}
                              disabled={formData?.type === 'view'}
                              selectedOptions={selectedOptions?.ownerId}
                              handleSelect={handleChange}
                              options={owner}
                              optionKeys={['userId', 'userName']}
                              errormsg={errormsg?.ownerId}
                              nameFormatter={true}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  borderColor: state.isFocused ? '#365397' : base.borderColor,
                                  borderWidth: state.isFocused ? '1px' : base.borderWidth,
                                  boxShadow: state.isFocused
                                    ? '0 0 5px rgba(0, 86, 179, 0.3)'
                                    : 'none',
                                  transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                                  '&:hover': {
                                    borderColor: '#365397',
                                  },
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  zIndex: 99999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? '#DEEBFF'
                                    : state.isFocused
                                      ? '#DEEBFF'
                                      : base.backgroundColor,
                                  color: state.isSelected
                                    ? '#222'
                                    : state.isFocused
                                      ? '#222'
                                      : base.color,
                                  cursor: 'pointer',
                                }),
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="input-container " id="taskstatus">
                            <SelectBox
                              label={'Status'}
                              name={'statusId'}
                              value={formData?.status}
                              selectedOptions={selectedOptions?.statusId}
                              placeholder={formData?.status}
                              handleSelect={handleChange}
                              options={ticketStatusDropdown}
                              optionKeys={['id', 'displayName']}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  borderColor: state.isFocused ? '#365397' : base.borderColor,
                                  borderWidth: state.isFocused ? '1px' : base.borderWidth,
                                  boxShadow: state.isFocused
                                    ? '0 0 5px rgba(0, 86, 179, 0.3)'
                                    : 'none',
                                  transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                                  '&:hover': {
                                    borderColor: '#365397',
                                  },
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  zIndex: 99999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? '#DEEBFF'
                                    : state.isFocused
                                      ? '#DEEBFF'
                                      : base.backgroundColor,
                                  color: state.isSelected
                                    ? '#222'
                                    : state.isFocused
                                      ? '#222'
                                      : base.color,
                                  cursor: 'pointer',
                                }),
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="input-container">
                            <TextArea
                              label={'Description'}
                              name={'description'}
                              placeholder={'Enter Description'}
                              value={formData?.description}
                              handleChange={handleChangeForm}
                              errormsg={errormsg?.description}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div
                            className="input-container"
                            style={{ position: 'relative' }}
                            id="remindpop"
                          >
                            <label htmlFor="#" className="selectlbl">
                              Reminder
                            </label>
                            <div className="toggle-container">
                              <label className="switch" style={{ margin: '0' }}>
                                <input
                                  type="checkbox"
                                  checked={formData.showReminder || false}
                                  onChange={handleReminderClick}
                                />
                                <span className="slider"></span>
                              </label>
                              {formData?.reminder && (
                                <span
                                  className="reminder-datetime"
                                  style={{
                                    marginLeft: '1rem',
                                    fontSize: '0.9rem',
                                    color: '#666',
                                  }}
                                >
                                  {new Date(formData?.reminder).toLocaleString('en-US', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: '2-digit',
                                    hour: 'numeric',
                                    minute: '2-digit',
                                    hour12: true,
                                  })}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </Form>
            </Formik>
            <div className="popup-footer">
              <button className="cancel_popup" onClick={togglePopupVisibility}>
                Cancel
              </button>
              <button
                className="save_popup"
                disabled={loading || !formData.subject}
                onClick={() => handleFormSubmit(formData)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ChildTicket;
